export const INIT = 'steppedForm/INIT';
export const SET_FORM = 'steppedForm/SET_FORM';
export const SET_STEP = 'steppedForm/SET_STEP';
export const SET_COMPLETE = 'steppedForm/SET_COMPLETE';
export const RESET_STEPS = 'steppedForm/RESET_STEPS';
